import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>Series 65 Exam Prep &mdash; practice questions, flashcards, and timed exams.</p>
      <p className="footer-disclaimer">
        Practice questions and answer explanations are AI-generated original content written in the style of the Series 65
        exam. They are not actual questions from any NASAA examination &mdash; NASAA copyrights its exam questions and
        prohibits their reproduction, so nothing here is drawn from a real exam.
      </p>
    </footer>
  );
}
